import ring from '@/public/images/for-business/jewelry/1_ring.webp';
import night from '@/public/images/for-business/jewelry/2_night.webp';
import hands from '@/public/images/for-business/jewelry/3_hands.webp';

export const forBusiness_jewelry_enhance = [
	{
		image: ring,
		columnTitle: 'enhancesData_column1_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'enhancesData_column1_title1',
				subtitle: 'enhancesData_column1_subtitle1',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column1_title2',
				subtitle: 'enhancesData_column1_subtitle2',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column1_title3',
				subtitle: 'enhancesData_column1_subtitle3',
			},
		],
	},
	{
		image: night,
		columnTitle: 'enhancesData_column2_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'enhancesData_column2_title1',
				subtitle: 'enhancesData_column2_subtitle1',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column2_title2',
				subtitle: 'enhancesData_column2_subtitle2',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column2_title3',
				subtitle: 'enhancesData_column2_subtitle3',
			},
		],
	},
	{
		image: hands,
		columnTitle: 'enhancesData_column3_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'enhancesData_column3_title1',
				subtitle: 'enhancesData_column3_subtitle1',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column3_title2',
				subtitle: 'enhancesData_column3_subtitle2',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column3_title3',
				subtitle: 'enhancesData_column3_subtitle3',
			},
		],
	},
];
